var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "theme-matching-confirm-view" }, [
    _c(
      "div",
      { staticClass: "theme-matching-confirm-content" },
      [
        _c("ChatMessage", {
          staticClass: "theme-matching-confirm-content__message",
          attrs: {
            message: _vm.$t("themeMatching.confirm.chatMessage"),
            "cat-icon-size": "medium",
            "use-writer-type": true,
          },
        }),
        _c(
          "div",
          { staticClass: "theme-matching-confirm-content__fields" },
          [
            _c("p", { staticClass: "fields-heading" }, [
              _vm._v(
                _vm._s(_vm.$t("themeMatching.confirm.referenceInfoHeading"))
              ),
            ]),
            _vm._l(_vm.novelInfoStatuses, function (field) {
              return _c(
                "p",
                {
                  key: field.name,
                  staticClass: "field-label",
                  class: { "field-label--empty": !field.filled },
                },
                [_vm._v(" " + _vm._s(field.label) + " ")]
              )
            }),
            _vm._l(_vm.fieldStatuses, function (field) {
              return _c(
                "p",
                {
                  key: field.name,
                  staticClass: "field-label",
                  class: { "field-label--empty": !field.filled },
                },
                [_vm._v(" " + _vm._s(field.label) + " ")]
              )
            }),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "theme-matching-confirm-content__fish-info" },
          [
            _c(
              "i18n",
              {
                staticClass: "fish-info-content fish-info-label",
                attrs: {
                  path: "themeMatching.confirm.fishCostLabel",
                  tag: "div",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "fish-info-amount",
                    attrs: { place: "amount" },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.formattedFishCost) +
                        " " +
                        _vm._s(_vm.$t("themeMatching.confirm.fishUnit"))
                    ),
                  ]
                ),
              ]
            ),
            _vm.isFishInsufficient
              ? _c("div", { staticClass: "fish-warning" }, [
                  _c("div", { staticClass: "fish-warning-icon" }, [
                    _vm._v("⚠️"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "fish-warning-content" },
                    [
                      _c("p", { staticClass: "fish-warning-message" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("themeMatching.confirm.fishInsufficient")
                          )
                        ),
                      ]),
                      _c(
                        "i18n",
                        {
                          staticClass: "fish-warning-detail",
                          attrs: {
                            path: "themeMatching.confirm.fishShortageDetail",
                            tag: "p",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "fish-shortage-amount",
                              attrs: { place: "amount" },
                            },
                            [_vm._v(_vm._s(_vm.formattedFishShortage))]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
        _c("div", { staticClass: "theme-matching-confirm-content__actions" }, [
          _c(
            "button",
            {
              staticClass: "theme-matching-confirm-content__request-button",
              class: {
                "theme-matching-confirm-content__request-button--insufficient":
                  _vm.isFishInsufficient &&
                  !_vm.isFanFictionWork &&
                  !_vm.isScriptModeWork,
              },
              attrs: { disabled: _vm.isRequestButtonDisabled },
              on: { click: _vm.handleRequest },
            },
            [_vm._v(" " + _vm._s(_vm.requestButtonText) + " ")]
          ),
          _c(
            "button",
            {
              staticClass: "theme-matching-confirm-content__back-button",
              attrs: { type: "button" },
              on: { click: _vm.handleBack },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("themeMatching.confirm.backButton")) + " "
              ),
            ]
          ),
        ]),
      ],
      1
    ),
    _c("div", { staticClass: "theme-matching-confirm-content__notice" }, [
      _vm.isFanFictionWork
        ? _c("p", { staticClass: "notice-text" }, [
            _vm._v(
              _vm._s(_vm.$t("themeMatching.validation.fanFictionDisabled"))
            ),
          ])
        : _vm._e(),
      _vm.isScriptModeWork
        ? _c("p", { staticClass: "notice-text" }, [
            _vm._v(
              _vm._s(_vm.$t("themeMatching.validation.scriptModeDisabled"))
            ),
          ])
        : _vm._e(),
      _c("p", { staticClass: "notice-text" }, [
        _vm._v(_vm._s(_vm.$t("themeMatching.confirm.noticeSavedContent"))),
      ]),
      _c("p", { staticClass: "notice-text" }, [
        _vm._v(_vm._s(_vm.$t("themeMatching.confirm.noticeNoLearning"))),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }